function mtInitReveal() {
  // Desactivado a propósito: el contenido siempre debe verse, sin depender
  // de que el usuario haga scroll o de que el JS llegue a tiempo. El CSS ya
  // muestra .mt-reveal visible por defecto; esta función se deja vacía
  // (en vez de borrarla) para no tener que tocar cada sección que la llama.
}

function mtInitGaleriaProducto() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-mt-galeria-principal]');
  var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-full');
      var alt = mini.getAttribute('data-alt') || '';
      if (!full) return;
      principal.src = full;
      principal.alt = alt;
      minis.forEach(function (m) { m.classList.remove('mt-mini-activa'); });
      mini.classList.add('mt-mini-activa');
    });
  });
}

function mtInitVariantes() {
  var forms = document.querySelectorAll('[data-mt-form-producto]');
  forms.forEach(function (form) {
    var selectores = form.querySelectorAll('[data-mt-opcion]');
    if (!selectores.length) return;
    var variantesInput = form.querySelector('[data-mt-variantes]');
    if (!variantesInput) return;
    var variantes;
    try {
      variantes = JSON.parse(variantesInput.textContent);
    } catch (e) {
      return;
    }
    var idInput = form.querySelector('input[name="id"]');
    var precioEl = form.querySelector('[data-mt-precio]');
    var precioComparadoEl = form.querySelector('[data-mt-precio-comparado]');
    var botonEl = form.querySelector('[data-mt-boton-comprar]');

    function actualizar() {
      var seleccion = [];
      selectores.forEach(function (sel) { seleccion.push(sel.value); });
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!variante) return;
      idInput.value = variante.id;
      if (precioEl && variante.price_formatted) precioEl.textContent = variante.price_formatted;
      if (precioComparadoEl) {
        if (variante.compare_at_price_formatted) {
          precioComparadoEl.textContent = variante.compare_at_price_formatted;
          precioComparadoEl.style.display = '';
        } else {
          precioComparadoEl.style.display = 'none';
        }
      }
      if (botonEl) {
        botonEl.disabled = !variante.available;
        botonEl.textContent = variante.available ? botonEl.getAttribute('data-texto-disponible') : botonEl.getAttribute('data-texto-agotado');
      }
    }
    selectores.forEach(function (sel) { sel.addEventListener('change', actualizar); });
  });
}

function mtInitComparador() {
  var cajas = document.querySelectorAll('[data-mt-comparador]');
  cajas.forEach(function (caja) {
    var input = caja.querySelector('[data-mt-comparador-input]');
    if (!input) return;
    function actualizar() {
      caja.style.setProperty('--mt-comp-pos', input.value + '%');
    }
    input.addEventListener('input', actualizar);
    actualizar();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  mtInitReveal();
  mtInitGaleriaProducto();
  mtInitVariantes();
  mtInitComparador();
});
